// Oregano and Cinnamon are returning different enums for similar errors.
// Common enums will be decided at a later time.
export enum ErrorType {
  // invalid is used as a catch all to show a generic failure message
  invalid = 'INVALID',
  duplicate = 'DUPLICATE',
  inappropriateContent = 'INAPPROPRIATE_CONTENT',
  pii = 'PII',
  containsPII = 'CONTAINS_PII',
  containsProfanity = 'CONTAINS_PROFANITY',
  inappropriateImage = 'INAPPROPRIATE_IMAGE',
  invalidImage = 'INVALID_IMAGE',
  usernameNotAvailable = 'USERNAME_NOT_AVAILABLE',
  invalidFormat = 'INVALID_FORMAT',
  maxCount = 'MAX_COUNT',
  deletedPost = 'DELETED_POST',
  postContainsReplies = 'POST_CONTAINS_REPLIES',
  unauthorizedAction = 'UNAUTHORIZED_ACTION',
  opNotSameMarketplace = 'OP_NOT_SAME_MARKETPLACE',
  opContainsReplies = 'OP_CONTAINS_REPLIES',
  updateWindowCrossed = 'UPDATE_WINDOW_CROSSED',
  cannotUpdateToDraft = 'CANNOT_UPDATE_TO_DRAFT',
  actionForbidden = 'ACTION_FORBIDDEN',
  postIsMarkedAsSolution = 'POST_IS_MARKED_AS_SOLUTION',
  unauthorizedMarketplaceId = 'UNAUTHORIZED_MARKETPLACE_ID',
  hasNoAccess = 'HAS_NO_ACCESS',
  duplicatePresent = 'DUPLICATE_PRESENT',
  maxLength = 'MAX_LENGTH',
  minLength = 'MIN_LENGTH',
  nonAmazonDomain = 'NON_AMAZON_DOMAIN',
  silenced = 'SILENCED',
  invalidContent = 'INVALID_CONTENT',
  none = 'NONE',
}

export interface ErrorResponse {
  [key: string]: ErrorType[] | undefined,
}

export interface ErrorsMap {
  [key: string]: {
    [key: string]: string
  }
}

export interface ValidationError {
  errorField: string,
  errors: string
}

export interface ErrorPayloadResponse {
  fieldErrors?: {
    [key: string]: ErrorType[],
  },
  actionErrors?: ErrorType[]
}
